import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { ProductListResponse, ProductQueryParams } from '@frontend/product/types';

export class ProductRequirementClient extends APIClient {
    public static readonly endpoint = '/product-api/v1';

    public static async fetchProductsNotInRequirement(
        accountId: string,
        spotId: string,
        queryParams?: ApiQueryParams<DefaultQueryParams | ProductQueryParams>
    ): Promise<ProductListResponse> {
        return await this.apiPaginated<ProductListResponse, DefaultQueryParams | ProductQueryParams>(
            `${this.endpoint}/accounts/${accountId}/spots/${spotId}/products`,
            queryParams
        );
    }
}
